import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
// import ReportWidjets from "./ReportWidjets"; // drawn by BoardSurface now
import BoardSurface from "./BoardSurface";
/* Redesigned filter panels. The originals are left in place for revert:
   Filters/index.js (data) and Filters/CustomFilters.js (global). */
// import Filters from "./Filters/index";
import Filters from "./Filters/DataFiltersPanel";
import { Row, Col, Select, Typography, Skeleton, Tabs, Button, Space, Popover, message, Collapse } from "antd";
// import ReactFullscreen from "react-easyfullscreen"; // moved to BoardSurface
import ConfirmDialog from "../../components/common/ConfirmDialog";
// import DownloadMenu from "../../components/common/DownloadMenu"; // moved to BoardSurface
import EmailReportModal from "../../components/common/EmailReportModal";
import { getResourcesAsync } from "../../redux/resourceSlice";
import {
  getBoardsAsync,
  updateSelectedBoard,
  getBoardByIdAsync,
  deleteBoardByIdAsync,
  resetBoardData,
  resetAllBoardData,
} from "../../redux/boardSlice";
import "./dashboardStyles.css";
import DashboardView from "../DashboardView";
// the editor toolbar's Refresh icon - same asset, so reload looks the same in both places
// import RefreshIcon from "../../assets/icons/reset-icon.svg"; // moved to BoardSurface
// import EmailShareIcon from "../../assets/icons/email-share.svg"; // moved to BoardSurface
class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      layout: [],
      value: "",
      timce: 100000000,
      anchorEl: null,
      setAnchorEl: null,
      visible: "invisible",
      selectedResource: null,
      // deleting the board is confirmed through the shared ConfirmDialog
      isDeleteConfirmOpen: false,
      // the Email dialog, opened from the envelope in the header toolbar
      isEmailOpen: false,
      /* Whether the widgets are still fetching. Starts true so Download and Email are
         disabled on first paint rather than enabling for the instant before the widgets
         report in. ReportWidjets owns the truth - see its reportBusyState. */
      isWidgetsBusy: true,
      /* Rows in the lone widget's table, for the pill beside the page title. Undefined
         until a widget reports one, which is what keeps the pill off a board that is
         still loading and off one whose single widget is a chart. */
      soleRowCount: undefined,
      /* Whether the board is currently filling the screen. Read off the document (see
         syncFullScreen) rather than set by the button, because Esc and F11 change it
         too - the header has to keep saying which way the toggle will go. */
      isFullScreen: false,
    };
    this.handleBannerChange = this.handleBannerChange.bind(this);
    // the widget rows live inside ReportWidjets, so board-level Export goes through here
    // this.widgetsRef = React.createRef();
    /* The widgets live inside BoardSurface now; it holds their ref as `widgetsRef`.
       Reached through this one for Export and Email's attachments. */
    this.surfaceRef = React.createRef();

    //  this.handleClose = this.handleClose.bind(this);
  }

  handleClose(event, newValue) {
    this.setState({
      visible: "invisible",
      value: "",
    });
  }

  handleBannerChange(event, newValue) {
    //  console.log(event.currentTarget)
    if (newValue === "fullscreen") {
      this.setState({
        visible: "visible",
        value: newValue,
      });
    } else if (newValue === "refresh") {
      this.setState({
        anchorEl: true,
        // setAnchorEl: event.currentTarget
      });
    } else if (newValue === "export") {
      /* There was no branch for this at all, so the Export button in the board header
         rendered and did nothing. On a dashboard download is now a per-widget property
         and each widget has its own button; this stays for reports, and for dashboards
         saved while board-level download was still a thing. */
      this.surfaceRef.current?.widgetsRef.current?.downloadAllWidgets?.();
    }
  }

  syncFullScreen = () => {
    const current = document.fullscreenElement || document.webkitFullscreenElement;
    this.setState({ isFullScreen: Boolean(current) });
  };

  componentDidMount() {
    document.addEventListener("fullscreenchange", this.syncFullScreen);
    document.addEventListener("webkitfullscreenchange", this.syncFullScreen);

    // if (!this.props.boards.selectedBoard) {
    this.props.getBoardByIdAsync({ id: this.props.match.params.boardId });
    // }

    // this.props.getResources()

    this.setState({
      visible: "invisible",
    });

    if (localStorage.getItem("setTimeRefresh")) {
      setInterval(() => window.location.reload(false), localStorage.getItem("setTimeRefresh"));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // if (this.props.match.params.boardId) {
    //   this.props.getBoardByIdAsync({ id: this.props.match.params.boardId });
    // }
    if (prevProps.match.params.boardId !== this.props.match.params.boardId) {
      this.props.getBoardByIdAsync({ id: this.props.match.params.boardId });
    }
    if (this.props.boards && this.props.boards.boardDeleteState === "success") {
      this.props.resetBoardData();
      this.props.history.push("/");
    }
  }

  componentWillUnmount() {
    document.removeEventListener("fullscreenchange", this.syncFullScreen);
    document.removeEventListener("webkitfullscreenchange", this.syncFullScreen);
    // this.props.resetAllBoardData()
  }

  onApplyFilterToResource = (resource) => {
    /* Was `resources: [resource]`, which replaced the board's whole resource list with
       the one being filtered - on a dashboard, applying a global filter to one widget
       made every other widget disappear. Only the matching resource is swapped. */
    const board = this.props.boards.selectedBoard;
    const key = (r) => r?.connectionData?.id ?? r?.id;

    this.props.updateSelectedBoard({
      ...board,
      resources: (board?.resources || []).map((r) => (key(r) === key(resource) ? resource : r)),
    });
    setTimeout(() => {
      this.setState({
        selectedResource: resource,
      });
    }, 100);
  };

  onApplyDataFilterToResource = (resource) => {
    // this.setState({
    //   selectedResource: null,
    // });
    // setTimeout(() => {
    //   this.setState({
    //     selectedResource: resource,
    //   });
    //   message.info("Filters have been applied!");
    // }, 100);
    /* Straight to the new filters. Going through null first un-filtered the table for
       100ms, so every Apply / Reset flashed all the rows before narrowing them. Data
       filters run in the browser (no fetch), so there is nothing to wait for. */
    this.setState({ selectedResource: resource });
    message.info("Filters have been applied!");
  };

  onResetFilterToResource = (resource) => {
    this.setState({
      selectedResource: { ...resource, dataFilters: [] },
    });
    message.info("Filters have been removed!");
  };

  handleLogOut = () => {
    this.props.logOut();
  };

  confirmDeleteBoard = () => {
    this.setState({ isDeleteConfirmOpen: false });
    this.props
      .deleteBoardById(this.props.match.params.boardId)
      .then(() => message.success("Board deleted successfully!"))
      .catch((err) => message.error("Oops, Board is not deleted!"));
  };

  /* Who made this board and when it last changed.

     This used to be printed inside every table widget, which meant a four-widget
     dashboard repeated the same three lines four times for information that describes
     the BOARD, not any one widget. It is rendered once here instead, under the widgets.

     "Created By" is the signed-in user's email, which is what the widget showed - the
     board record carries no author field, so a name or role is not available yet. */
  renderBoardMeta = (board) => {
    const stamp = (value) => {
      if (!value) return null;
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return null;
      const date = `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getDate()).padStart(2, "0")}`;
      return `${date} ${d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })}`;
    };

    const email = this.props.user?.user?.username || "";
    const rows = [
      { label: "Created By", value: board.createdBy || email },
      { label: "Created At", value: stamp(board.createdAt) },
      { label: "Last Modified", value: stamp(board.updatedAt) },
      { label: "Modified By", value: board.modifiedBy || email },
    ];

    // with no dates and no signed-in user there is nothing to state
    if (!rows.some((r) => r.value)) return null;

    return (
      <div className="dbv-meta-card">
        {rows.map((row) => (
          <div className="dbv-meta-row" key={row.label}>
            <span className="dbv-meta-label">{row.label}:</span>
            <span className="dbv-meta-value">{row.value || "—"}</span>
          </div>
        ))}
      </div>
    );
  };

  render() {
    /* The toolbar logic (auto refresh interval, download, full screen, busy state, the
       row-count pill) moved with the markup into BoardSurface. What is left here is
       what this page alone needs: which board, and the Back / Edit / Delete icons. */
    const board = this.props.boards && this.props.boards.selectedBoard;
    const isReport = board && board.configDetails && board.configDetails.boardType === "reports";
    const typeLabel = isReport ? "Report" : "Dashboard";

    const BackIcon = (
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" width="14" height="14">
        <path d="M10 3L5 8l5 5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
    const EditIcon = (
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" width="14" height="14">
        <path d="M10.5 2.5l3 3-8 8H2.5v-3l8-8z" strokeLinejoin="round" />
      </svg>
    );
    const DeleteIcon = (
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" width="14" height="14">
        <path d="M2.5 4h11M6 4V2.5h4V4M6.5 7v4M9.5 7v4M3.5 4l.8 9.5h7.4L12.5 4" strokeLinecap="round" />
      </svg>
    );

    return (
      // noMargin so the grey page canvas runs to the edges; padding lives on .dbv-shell
      <DashboardView noMargin={true}>
        <div className="dbv-shell">
          {/* The header, board toolbar, full screen and widgets moved into BoardSurface
              (same code), so the editor's Preview draws exactly this page. The previous
              inline version is in git history. This page adds what only it has: Back /
              Edit / Delete, Email, and filters applied to the saved board in the store. */}
          <BoardSurface
            ref={this.surfaceRef}
            board={board}
            // isLoading={this.props.boards.boardsStatus === "pending"}
            /* This request's own status — boardsStatus is shared with the boards
               list and was overwritten by it (see boardSlice). */
            isLoading={["default", "pending"].includes(this.props.boards.selectedBoardStatus)}
            loadError={this.props.boards.selectedBoardError}
            onRetry={() => this.props.getBoardByIdAsync({ id: this.props.match.params.boardId })}
            selectedResource={this.state.selectedResource}
            onApplyGlobalFilter={this.onApplyFilterToResource}
            onApplyDataFilter={this.onApplyDataFilterToResource}
            onResetDataFilter={this.onResetFilterToResource}
            onEmail={() => this.setState({ isEmailOpen: true })}
            headerActions={
              <>
                {/* Back is not in the mockup but the view is reached from the list,
                    so it stays alongside Edit / Delete. */}
                <button className="dbv-btn dbv-btn-edit" onClick={() => window.history.back()}>
                  {BackIcon}
                  Back
                </button>
                <button
                  className="dbv-btn dbv-btn-edit"
                  onClick={() =>
                    this.props.history.push(
                      `/editor/${isReport ? "reports" : "dashboard"}/${this.props.match.params.boardId}`,
                    )
                  }
                >
                  {EditIcon}
                  Edit
                </button>
                <button className="dbv-btn dbv-btn-delete" onClick={() => this.setState({ isDeleteConfirmOpen: true })}>
                  {DeleteIcon}
                  Delete
                </button>
              </>
            }
          />

          <ConfirmDialog
            open={this.state.isDeleteConfirmOpen}
            danger
            title={`Delete this ${typeLabel}?`}
            message={`"${board?.name || typeLabel}" will be removed permanently. This cannot be undone.`}
            onCancel={() => this.setState({ isDeleteConfirmOpen: false })}
            onConfirm={this.confirmDeleteBoard}
          />

          {/* ── EMAIL THIS REPORT ──
              The attachment is built on Send, not here, so the PDF holds the filters as
              they stand at that moment. buildEmailAttachments reaches every table widget
              through the same ref the download menu uses.

              Reply_To is the signed-in user, so a reply reaches whoever sent it rather
              than the no-reply address the mail goes out from. */}
          <EmailReportModal
            open={this.state.isEmailOpen}
            reportName={board?.name}
            /* `username` IS the address - it is what renderBoardMeta prints as the
               board's author, and what the login stores. `email` is checked first only
               in case the shape ever gains a properly named field. */
            defaultReplyTo={this.props.user?.user?.email || this.props.user?.user?.username}
            buildAttachments={() => this.surfaceRef.current?.widgetsRef.current?.buildEmailAttachments?.() ?? []}
            onClose={() => this.setState({ isEmailOpen: false })}
          />
        </div>
      </DashboardView>
    );
  }
}

const mapStateToProps = (state) => {
  const { boards, user } = state;
  return {
    boards: boards,
    // the meta card shows the signed-in user's email as the board's author
    user: user,
    currentAppPermissions: user.currentAppPermissions ? user.currentAppPermissions : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // dispatching plain actions
    getBoardByIdAsync: (data) => dispatch(getBoardByIdAsync(data)),
    updateSelectedBoard: (data) => dispatch(updateSelectedBoard(data)),
    deleteBoardById: (id) => dispatch(deleteBoardByIdAsync(id)),
    resetBoardData: () => dispatch(resetBoardData()),
    resetAllBoardData: () => dispatch(resetAllBoardData()),
    getResources: () => dispatch(getResourcesAsync()),
    // addSelectedBoard: (board) => dispatch(updateSelectedBoard(board)),
    // setOtherUsers: (usersList) => dispatch(setOtherUsers(usersList)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Dashboard));
